// extracted by mini-css-extract-plugin
module.exports = {"purpleBox":"HandoverOptionsScreen_purpleBox__NmxwP","email":"HandoverOptionsScreen_email__h1Lvp"};